/**
 * Normalize language code to BCP 47 format for Intl APIs
 * Converts underscore to hyphen and capitalizes region code
 * @param {string} lang Language code (e.g., 'pt_br', 'en_US', 'pt-br')
 * @returns {string} Normalized BCP 47 language tag (e.g., 'pt-BR', 'en-US')
 */
export const normalizeLocale = (lang) => {
  if (!lang) return 'en';
  const [language, region] = lang.replace(/_/g, '-').split('-');
  return region ? `${language.toLowerCase()}-${region.toUpperCase()}` : language.toLowerCase();
};

/**
 * Format seconds into human readable string
 * @param {number} seconds Time in seconds
 * @returns {string} Human readable value
 */
export const formatSeconds = (seconds) => {
  seconds = parseInt(`${seconds || 0}`)

  const hours = +(seconds / 3600).toFixed(1)
  const minutes = Math.floor(seconds / 60)

  const value = hours >= 1 ? hours : minutes || seconds
  const label = hours >= 1 ? 'ore' : minutes ? 'minuti' : 'secondi'

  return `${value} ${label}`
}

/**
 * Format timestamp into human readable string
 * @param {number} timestamp Date timestamp
 * @returns Human readable value
 */
import { DateTime } from 'luxon'
export const formatDate = (timestamp) => {
  if (!timestamp) return '';
  
  let date = DateTime.fromFormat(timestamp, 'yyyy-MM-dd HH:mm:ss')
  if (!date.isValid) date = DateTime.fromFormat(timestamp, 'yyyy-MM-dd')
  
  return new Intl.DateTimeFormat('it', {
    day: 'numeric',
    month: '2-digit',
    year: 'numeric',
  })
    .format(date)
    .replace(/[ /]/g, '.')
}

